import CancelledApplicationsContainer from "../../../Components/Applications/CancelledApplications";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const CancelledApplications = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Cancelled Applications";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "recruiter"]}
      />

      {/* Main content */}
      <CancelledApplicationsContainer/>
    </>
  );
};

export default CancelledApplications;
